/**
 * Created by Christof Sander on 19.10.2016.
 */

const utils = require('../../lib/utils')
module.exports = {
	extends: [
		'/',
		'base',
		'mediaManagement',
		'actionsForm'
	],

	config: {
		type: 'filter',
		defaultSortField: 'mediaID',
		defaultSortDirection: 'DESC',
		resourceConnected: false
	},

	model: {
		tags: {
			listOfCategoryDataIDs: [],
			data: []
		}
	},

	methods: {
		showFilter: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this
			if(buttonContext === 'tags'){
				if(!self.model.tagPickerButton){
					self.closest(self.config.actionBossComponentClass, function(image){
						image.find('base_form_fields_tag-picker-button', function(tagPickerButton){
							self.model.tagPickerButton = tagPickerButton
						})
					})
				}

				self.model.tagPickerButton.open(self.model.tags.data, options => {
					utils.forEach(((options || {}).decisionOptions || {}).dirtyAssignedTags || {}, function(tag){
						if(tag.type === 'delete'){
							self.model.tags.listOfCategoryDataIDs[tag.relationDataIndex] = 0
							delete self.model.tags.data[tag.relationDataIndex]
						} else {
							self.model.tags.listOfCategoryDataIDs[tag.relationDataIndex] = tag.categoryDataID
							self.model.tags.data[tag.relationDataIndex] = {
								attributes: tag
							}
						}
					})
					self.filterChanged()
				})
				return utils.promise.resolve()
			}

			return utils.promise.reject()
		},

		filterChanged: function(){
			var filters = utils.copy(((this.model.dirtyFields || {}).data || {}).attributes || {})
			if(this.config.type === 'filter') {
				filters.listOfCategoryDataIDs = this.model.tags.listOfCategoryDataIDs
				filters.originalName = filters.originalName || ''
			} else {
				filters.order = {
					fieldCode: 	filters.orderField || this.config.defaultSortField || 'mediaID',
					direction: 	filters.orderDirection || this.config.defaultSortDirection || 'DESC'
				}
				delete filters.orderField
				delete filters.orderDirection
			}
			this.triggerClosest('filterChanged', { filters })
		},

		onChange: function(isRelationChange, changeDone, fieldData){
			this.filterChanged()
		}
	}
}